import axios from 'axios';
/* We need to source this package until we remove service-client */
import fetch from 'isomorphic-fetch'; // eslint-disable-line


const DEFAULT_TIMEOUT = 5 * 10000;

export function get(url, options = {}) {
  const requestOptions = { timeout: DEFAULT_TIMEOUT, ...options };
  return axios.get(url, requestOptions)
    .then(response => response)
    .catch(e => (console.log(e), ({ body: JSON.stringify({}), statusCode: e.response && e.response.status })));
}

export const { post } = axios;

export function erase() {}
